module.exports = __webpack_public_path__ + "media/images/actualizar2-54cd9695b248ee52c24112638a03f408.svg";